import React, { FC, useEffect } from 'react';
import { SitePreviewPreview } from './SitePreviewPreview';
import styles from './SitePreviewPremium.scss';
import { SitePreviewPremiumContent } from './components/SitePreviewPremiumContent';
import { useSelectedStoreName } from 'stores/appStore';
import { useGTM } from 'hooks/useGTM';
import premiumHalfOff from 'assets/images/premium-half-off.png';

export const SitePreviewPremium: FC = () => {
  const { trackPreviewPageView } = useGTM();
  const storeName = useSelectedStoreName();

  useEffect(() => {
    trackPreviewPageView(storeName || undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.sitePreviewPremium}>
      <div className={styles.sitePreviewPremiumHalfOff}>
        <img src={premiumHalfOff} alt="premium half off" />
      </div>
      <div className={styles.sitePreviewPremiumContent}>
        <SitePreviewPremiumContent />
      </div>
      <div className={styles.sitePreviewPremiumPreview}>
        <SitePreviewPreview />
      </div>
    </div>
  );
};
